import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=ae653f20&scoped=true"
import script from "./PasswordResetView.vue?vue&type=script&lang=js"
export * from "./PasswordResetView.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetView.vue?vue&type=style&index=0&id=ae653f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae653f20",
  null
  
)

export default component.exports